<template>
    <div style="height: 100%;">
        <AgendaList v-show="!rotaAninhada" :reloadData="reloadData" />
        <router-view />
    </div>
</template>

<script>
import AgendaList from '@/components/vendas/agenda/AgendaList.vue';

export default {
    name: 'AgendaListRoute',

    beforeRouteUpdate(to, from, next) {
        this.rotaAninhada = to.name != 'crm-agenda-list';
        if (from.name != 'crm-agenda-list' && to.name == 'crm-agenda-list') {
            this.reloadData = true;
            setTimeout(() => (this.reloadData = false), 300);
        } 
        next();
    },
    components: {
        AgendaList,
    },
    data() {
        return {
            rotaAninhada: false,
            reloadData: false,
        };
    },
    created() {
        this.rotaAninhada =
            this.$route.name.includes('crm-agenda') &&
            this.$route.name != 'crm-agenda-list';
    },
};
</script>
